import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppPurchaseOrdersPage.';
  public static readonly purchaseOrderSummaryTitle = `${Id.prefix}purchaseOrderSummaryTitle`;
}

export class LangAppPurchaseOrdersPage {
  private constructor() {}
  public static purchaseOrderSummaryTitle(): string {
    return interpolate(Id.purchaseOrderSummaryTitle);
  }
}

export class AppPurchaseOrdersPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderSummaryTitle,
      "{{glossary 'purchase-order'}} Summary",
      'Title for the purchase orders summary page'
    );
  }
}
